module.exports = __webpack_public_path__ + "img/lab-login.4db0cf35.png";